import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { isPlatformBrowser } from '@angular/common';
import { ChangeDetectorRef, Component, inject, Input, PLATFORM_ID, signal } from '@angular/core';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CoreLookUpService } from 'src/app/services/feature/kb-my-cores/kbMyCores.service';
import { finalize } from 'rxjs';
@Component({
  selector: 'app-coreMaterialTab',
  templateUrl: './KbcoreMaterialTab.component.html',
  styleUrls: ['./KbcoreMaterialTab.component.scss'],
  standalone: false
})
export class KbCoreMaterialTabComponent {
  isMobile: boolean = false;
  tableContent: any;
  subscription = new Subscription();
  searchQuery1: string = '';
  searchQuery2: string = '';
  @Input() caller: string = '';
  searchType: string = '';
  platformId = inject(PLATFORM_ID);
  isLoading = signal<boolean>(false);
  private loaderEl: HTMLElement | null = null
  constructor(private service: CoreLookUpService,
    private breakpointObserver: BreakpointObserver,
    private cdr: ChangeDetectorRef,
    private router: Router
  ) {
    this.subscription.add(this.breakpointObserver
      .observe([Breakpoints.XSmall, Breakpoints.Small])
      .subscribe((result) => {
        this.isMobile = result.matches;
      }));
  }
  ngOnInit() {
    if (this.isMobile) {
      this.setCustomWidth()
    }
  }
  setCustomWidth() {
    if (isPlatformBrowser(this.platformId)) {
      const widthInPixels = window.innerWidth - 20;
      document.documentElement.style.setProperty('--custom-naMaterialCoreTab-width', `${widthInPixels}px`);
    }
  }
  search1ApiCall(currentPage) {
    if (isPlatformBrowser(this.platformId)) {
      let pageName;
      if (window.location.href.indexOf('kbCoreSubmissionPage') > -1) {
        pageName = 'coreSubmissionPage'
      }
      if (this.searchQuery1.trim().length > 0) {
        this.showLoader();
        this.service.search1(this.searchQuery1.trim(), currentPage, pageName).pipe(finalize(() => this.hideLoader())).subscribe({
          next: (tableData) => {
            this.tableContent = tableData;
            this.searchType = 'search1';
            this.cdr.detectChanges();
          },

          error: () => {
            this.hideLoader()
          }
        });
      }
    }
  }
  search2ApiCall(currentPage) {
    if (this.searchQuery2.trim().length > 0) {
      this.showLoader();
      this.service.search2(this.searchQuery2.trim(), currentPage).pipe(finalize(() => this.hideLoader())).subscribe({
        next: (tableData) => {
          this.tableContent = tableData;
          this.searchType = 'search2';
          this.cdr.detectChanges();
        },
        error: () => {
          this.hideLoader();
        }
      });
    }
  }

  changePageCustom(e, data) {
    if (this.searchType == 'search1') {
      this.search1ApiCall(e);
    } else {
      this.search2ApiCall(e);
    }
  }

  addToCoreForm(item) {
    if (isPlatformBrowser(this.platformId)) {
      if (window.location.href.indexOf('CoreInfoCenter') > -1) {
        setTimeout(() => {
          this.service.addCoreFormData.next(item);
        }, 2000)
        this.router.navigate(['kbCoreSubmissionPage']);
      } else {
        this.service.addCoreFormData.next(item);
      }
    }
  }

  showLoader() {

    if (!this.loaderEl) {
      this.loaderEl = document.createElement('div');
      this.loaderEl.className = 'kb-global-loader';

      this.loaderEl.innerHTML = `
      <div class="kb-loader-wrap">
        <div class="kb-spinner"></div>
      </div>
    `;
      const overlayWrapper = document.querySelector('.materialTabbgWrapper');

      if (overlayWrapper) {
        overlayWrapper.appendChild(this.loaderEl);
      } else {
        document.body.appendChild(this.loaderEl);
      }

    }

  }

  hideLoader() {
    if (this.loaderEl && this.loaderEl.parentNode) {
      this.loaderEl.parentNode.removeChild(this.loaderEl);   // ✅ correct
      this.loaderEl = null;
    }
  }
}
